require('select2');
require('select2/dist/css/select2.min.css');
require('tools/jquery.autocomplete');

$.fn.getForm2obj = function() {
    var _ = {};
    $.map(this.serializeArray(), function(n) {
      const keys = n.name.match(/[a-zA-Z0-9_]+|(?=\[\])/g);
      if (keys.length > 1) {
        var tmp = _;
        pop = keys.pop();
        for (var i = 0; i < keys.length, j = keys[i]; i++) {
          tmp[j] = (!tmp[j] ? (pop == '') ? [] : {} : tmp[j]), tmp = tmp[j];
        }
        if (pop == '') tmp = (!Array.isArray(tmp) ? [] : tmp), tmp.push(n.value);
        else tmp[pop] = n.value;
      } else _[keys.pop()] = n.value;
    });
    return _;
}

var repairData = {
    serial: 0,
    ean13: 0,
    id_product: 0
};
function getRepairProduct() {

    var inputContainer = $('#section_1');

    inputContainer.find('.error').remove();

    $.ajax({
        type: 'POST',
        url: baseUri + '?rand=' + new Date().getTime(),
        async: true,
        cache: false,
        dataType : "json",
        headers: { "cache-control": "no-cache" },
        data:
        {
            controller: 'repair',
            ajax: true,
            token: token,
            action: 'getProduct',
            ean13: repairData.ean13,
            serial: repairData.serial,
            id_product: repairData.id_product,
        },
        success: function(data)
        {
            if( data.error ) {
                inputContainer.append('<p class="error">' + data.message + '</p>');
                return;
            }

            if( !data.success ) {
                return;
            }

            if( data.continue_product ){
                $('input[name="id_custom_product"]').val(1);
                $('.repair-product-search .js-warning').html( data.message + '<br><a href="#" id="ManualProduct">Continuer avec ce numéro de série</a>');
                return;
            }

            $('input[name="id_custom_product"]').val('');
            $('#my_repair_product_name').text(data.product.product_name);
            $('#my_product_reference').text(data.product.reference);
            $('input[name="id_product"]').val(data.product.id_product);
            $('input[name="ean13"]').val(data.product.ean13);
            $('input[name="serial"]').val(data.product.serial);

            if( data.product.store_name ){
                $('#my_product_store').text(data.product.store_name);
            }else{
                $('#my_product_store').parent().hide();
            }

            if( data.product.bought_date ){
                $('#my_product_serial_date').text(data.product.bought_date);
            }else{
                $('#my_product_serial_date').parent().hide();
            }

            if( data.product.serial_status ) {
                $('#my_product_serial_warrantly').text(data.product.serial_status);
            }else{
                $('#my_product_serial_warrantly').parent().hide();
            }

            if( $('#mount').find('option[value="' + data.product.mount + '"]').length ){
                $('#mount').find('option[value="' + data.product.mount + '"]').prop('selected', true);
            }

            setAccessorySelect(data.product.accessories);

            setJoinAccessorySelect(data.joinProduct.accessories);

            var joinProductType = data.joinProduct.product_type.toLowerCase();
            $('.join_product_type').text(joinProductType);
            $('input[name="join[product_type]"]').val(joinProductType);

            setDefectSelect(data.defects);

            if( data.message ) {
                $('.repair-product-search .js-warning').html( data.message + '<br><a href="#" id="SerialNextStep">Continuer</a>');
                return;
            }

            // $('#section_1').hide();
            // $('#section_2').fadeIn('fast');
            $('#section_1').removeClass('active');
            $('#section_2').addClass('active');

            $('body').stop().animate({
                scrollTop: $('#section_2').offset().top
            }, 500);

        }
    });
}

function setAccessorySelect(accessories) {
    $("#add_accessories").html('').select2({
        data: accessories,
        tags: true,
    });
}

function setJoinAccessorySelect(accessories) {
    $("#add_join_accessories").html('').select2({
        data: accessories,
        tags: true,
    });
}

function setDefectSelect(defects) {
    $("#add_defects").html('').select2({data: defects});
}

function sendRepair() {

    $("#send_repair_form").prop('disabled', true);

    var joinFields = [
        '#join_brand',
        '#join_model',
        '#join_mount',
        '#join_serial',
        '#add_join_accessories',
    ];

    // join product fields
    var joinProductFieldRequired = false;
    if( parseInt($('input[name="join_product"]:checked').val()) ){
        joinProductFieldRequired = true;
    }
    $.each(joinFields, function( index, field ) {
        $(field).attr('required', joinProductFieldRequired);
    });

    // custom product choice
    if( $('input[name="id_custom_product"]').val() ) {
        $('input[name="product_name"]').attr('required', true);
    }

    // validate form
    if( !document.getElementById("repair_form").reportValidity() ){
        $("#send_repair_form").prop('disabled', false);
        return false;
    }

    var data = $("#repair_form").getForm2obj();

    $.ajax({
        type: 'POST',
        url: baseUri + '?rand=' + new Date().getTime(),
        async: true,
        cache: false,
        dataType : "json",
        headers: { "cache-control": "no-cache" },
        data:
        {
            controller: 'repair',
            ajax: true,
            token: token,
            action: 'sendRepair',
            data: data,
        },
        success: function(data)
        {
            if( data.error ) {
                $('.repair-product-search').append('<p class="error">' + data.message + '</p>');
                return;
            }

            if( !data.success ) {
                return;
            }

            $('#repair_form').hide();
            $('#section_success p:first').html('Nous avons bien reçu votre demande de prise en charge SAV');
            $('#section_success').addClass('active');

            $('html, body').animate({
                scrollTop: $('main').offset().top
            }, 500);

        }
    });

}

function initRepair() {

    if( !$('#repair').length ) {
        return;
    }

    $('#add_accessories').select2();

    $('.repair-products a').on('click', function(e){
        e.preventDefault();

        repairData.ean13 = $(this).data('ean13');
        repairData.serial = $(this).data('serial');
        $('input[name="ean13"]').val(repairData.ean13);
        $('input[name="serial"]').val(repairData.serial);

        getRepairProduct();
    });

    $('#searchSerial').on('click', function(e){
        e.preventDefault();

        $('.repair-product-search .error').remove();

        var inputSerial = $('input[name="serial"]')[0];
        if( !inputSerial.validity.valid ){
            $('input[name="serial"]').parent().append('<p class="error">Veuillez renseigner votre numéro de série</p>');
            return false;
        }

        var inputEan = $('input[name="ean13"]')[0];
        if( !inputEan.validity.valid ){
            $('input[name="ean13"]').parent().append('<p class="error">Veuillez renseigner votre code EAN</p>');
            return false;
        }

        repairData.serial = $('input[name="serial"]').val();
        repairData.ean13 = $('input[name="ean13"]').val();

        getRepairProduct();

    });

    $('.repair-product-search').on('click', '#ManualProduct', function(e){
        e.preventDefault();

        $('.repair-product-search').hide();
        $('#search_product_by_name').show();

    });

    $('.repair-product-search').on('click', '#SerialNextStep', function(e){
        e.preventDefault();

        $('#section_1').removeClass('active');
        $('#section_2').addClass('active');

        $('body').stop().animate({
            scrollTop: $('#section_2').offset().top
        }, 500);

    });

    // add input field for special accessory
    $('#add_accessories').on('select2:select', function (e) {
        var data = e.params.data;
        if( data.suffix ) {
            var html = '<div class="form-group"><label>' + data.text + '</label><input type="text" name="accessory_questions['+ data.id +']" value=""/><span class="suffix"> ' + data.suffix + '</span></div>';
            $('#custom_accessories').append(html);
        }
    });

    $('#add_join_accessories').on('select2:select', function (e) {
        var data = e.params.data;
        if( data.suffix ) {
            var html = '<div class="form-group"><label>' + data.text + '</label><input type="text" name="accessory_questions['+ data.id +']" value=""/><span class="suffix"> ' + data.suffix + '</span></div>';
            $('#custom_join_accessories').append(html);
        }
    });

    $('input[name="join_product"]').on('change', function(e){
        e.preventDefault();
        if( parseInt($('input[name="join_product"]:checked').val()) ){
            $('#join_product').show();
        }else{
            $('#join_product').hide();
        }
    });

    $('input[name="is_pro"]').on('change', function(e){
        e.preventDefault();
        if( parseInt($('input[name="is_pro"]:checked').val()) ){
            $('#company-details').addClass('active');
        }else{
            $('#company-details').removeClass('active');
        }
    });

    $('#send_repair_form').on('click', function(e){
        e.preventDefault();
        sendRepair();
    });

    // Product search by name
    $('#repair_product_name').autocomplete(
        $('#product_search_url').val(),
        {
            minChars: 3,
            max: 20,
            selectFirst: false,
            scroll: false,
            dataType: "json",
            formatItem: function(data, i, max, value, term) {
                return value;
            },
            parse: function(data) {
                var mytab = [];
                for (var i = 0; i < data.length; i++)
                    mytab[mytab.length] = { data: data[i], value: data[i].cname + ' > ' + data[i].pname };
                return mytab;
            },
            extraParams: {
                ajaxSearch: 1,
                id_lang: id_lang,
                min_score: 'title',
            }
        }
    )
    .result(function(event, data, formatted) {
        console.log(data);
        $('#repair_product_name').val(data.pname);
        $('input[name="id_product"]').val(data.id_product);

        repairData.id_product = data.id_product;
        getRepairProduct();
    });

}

module.exports = initRepair;


// WEBPACK FOOTER //
// ./js/repair.js